import { render, staticRenderFns } from "./people.vue?vue&type=template&id=51e8ff5e&scoped=true"
import script from "./people.vue?vue&type=script&lang=ts"
export * from "./people.vue?vue&type=script&lang=ts"
import style0 from "./people.vue?vue&type=style&index=0&id=51e8ff5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e8ff5e",
  null
  
)

export default component.exports